import React, { useEffect } from 'react'
import { useParams } from "react-router-dom";
import { getOrder } from "../redux/actions/user";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Redirect } from 'react-router-dom';





function Verifypayment({ getOrder, order }) {
    const { orderid } = useParams();
    useEffect(() => {
        getOrder(orderid);
    }, [orderid]);

    if (order.order_info) {
        return <Redirect to={`/order/${orderid}`} />
    }


    return (
        <>
            <header className="fixed header-blue">
                <div className="container">
                    <div className="header-top">
                        <div className="header-top-left">
                        </div>
                        <div className="header-top-mid">
                            <span className="font-semibold">Order Payment Verification</span>
                        </div>
                        <div className="header-top-right"></div>
                    </div>
                </div>
            </header>
            <div className="previous-orders-main" style={{ marginTop: "51px" }}>
                {!order.order_info && <div className="alert alert-danger">
                    Your payment was Unsuccessful.
                <Link to="/finalcart">Try Again</Link>
                </div>}
            </div>
        </>

    )
}

const mapStateToProps = (state) => ({
    order: state.user.selectedOrder
})

export default connect(mapStateToProps, { getOrder })(Verifypayment)
